export const VueDashboardItemClasses =
{
    Container: "vueDashboardItem",
    Busy: "vueDashboardItem--busy",
    FatalError: "vueDashboardItem--fatalError",
    Inner: "vueDashboardItem__inner",
    ContainerSelected: "vueDashboardItem--selected",
    Header: "vueDashboardItem__header",
    HeaderTitle: "vueDashboardItem__headerTitle",
    HeaderTitleLink: "vueDashboardItem__headerTitleLink",
    HeaderTitleText: "vueDashboardItem__headerTitleText",
    HeaderSpacer: "vueDashboardItem__headerSpacer",
    HeaderTitleClickable: "vueDashboardItem__headerTitle--clickable",
    DragHandle: "vueDashboardItem__dragHandle",
    ResizeHandle: "vueDashboardItem__resizeHandle",
    SubHeader: "vueDashboardItem__subheader",
    Body: "vueDashboardItem__body",
    ErrorBody: "vueDashboardItem__errorBody",
    ErrorBodySmallWidth: "vueDashboardItem__errorBody--smallWidth",
    ErrorBodySmallHeight: "vueDashboardItem__errorBody--smallHeight",
    SecurityErrorBody: "vueDashboardItem__securityErrorBody",
    SecurityErrorBodyText: "vueDashboardItem__securityErrorBodyText",
    ErrorActionButton: "vueDashboardItem__errorActionButton",
    ErrorActionButtonTall: "vueDashboardItem__errorActionButton--tall",
    ErrorHeader: "vueDashboardItem__errorHeader",
    DashboardItemInformationText: "dashboardItemInformation__text",
    DashboardItemInformationUnorderedList: "dashboardItemInformation__unorderedList",
    FilterHeader: "vueDashboardItem__filterHeader",
    FilterButton: "vueDashboardItem__filterButton",
    BreadcrumbsHeader: "vueDashboardItem__breadcrumbsHeader",
    BreadcrumbsBackButton: "vueDashboardItem__breadcrumbsBackButton",
    BreadcrumbsBackButtonText: "vueDashboardItem__breadcrumbsBackButtonText",
    BreadcrumbsDelimiter: "vueDashboardItem__breadcrumbsDelimiter",
    BreadcrumbsDescription: "vueDashboardItem__breadcrumbsDescription",
};

Object.freeze(VueDashboardItemClasses);

export const VueDashboardItemTileClasses =
{
    Content: "vueDashboardItemTile__content",
    ErrorContent: "vueDashboardItemTile__errorContent",
    ErrorContentRefresh: "vueDashboardItemTile__errorContent--refresh",
    ErrorContentWide: "vueDashboardItemTile__errorContent--wide",
    ErrorContentTall: "vueDashboardItemTile__errorContent--tall",
    ErrorContentLight: "vueDashboardItemTile__errorContent--light",
    ErrorContentText: "vueDashboardItemTile__errorContentText",
    ErrorContentTextRefreshHeader: "vueDashboardItemTile__errorContentText--refreshHeader",
    ErrorContentTextRefresh: "vueDashboardItemTile__errorContentText--refresh",
    ContentButton: "vueDashboardItemTile__contentButton",
    ContentContainer: "vueDashboardItemTile__contentContainer",
    Svg: "vueDashboardItemTile__svg",
    ErrorContentSvg: "vueDashboardItemTile__errorContentSvg",
    Icon: "vueDashboardItemTile__icon",
    IconLarge: "vueDashboardItemTile__icon--large",
    TileTitleContainer: "vueDashboardItemTile__titleContainer",
    TileTitle: "vueDashboardItemTile__title",
    IconContainer: "vueDashboardItemTile__iconContainer",
    IconContainerLarge: "vueDashboardItemTile__iconContainer--large",
    LiveTileRecordCount: "vueDashboardItemLiveTile__recordCount",
    SectionTileSectionDataContainer: "vueDashboardItemSectionTile__sectionDataContainer",
    SectionTileSectionData: "vueDashboardItemSectionTile__sectionData"
};

Object.freeze(VueDashboardItemTileClasses);

export const VueDashboardItemWellnessScreeningClasses =
{
    Heading: "vueDashboardItemWellnessScreeningTile__heading",
    Title: "vueDashboardItemWellnessScreeningTile__title",
    Content: "vueDashboardItemWellnessScreeningTile__content",
    Svg: "vueDashboardItemWellnessScreeningTile__svg",
    StatusContainer: "vueDashboardItemWellnessScreeningTile__statusContainer",
    Status: "vueDashboardItemWellnessScreeningTile__status",
};

Object.freeze(VueDashboardItemWellnessScreeningClasses);